import { BucketBet } from '../api/strategy';

export type SummaryBet = BucketBet & {
  live_enabled?: boolean; currently_selected?: boolean | null;
  market_status?: string | null; in_play?: boolean; market_updated_at?: string | null;
};
export const venueKey = (value: string) => value.toUpperCase().trim().replace(/[^A-Z0-9]/g, '');
const runnerKey = (value: string) => venueKey(value.replace(/^\d+[.]?\s*/, ''));
export type SummaryRace = {
  key: string; track: string; race: number; time: number;
  picks: Map<string, {name:string; entries:Map<string,SummaryBet>}>;
};
export const currentPick = (b: SummaryBet) => b.result === 'pending' && (b.currently_selected !== false || b.placed);
export function groupRaceSummary(bets: SummaryBet[], scope: string, byTime: boolean, now: number) {
  const byRace = new Map<string,SummaryRace>(), labels = new Map<string,string>();
  // Venue history always uses every paper/live WIN bucket, independently of the display filter.
  const winnerVenues = new Set(bets.filter(b => b.result === 'win' && b.market_type === 'WIN'
    && String(b.side).toLowerCase() !== 'lay' && b.track && !b.retrospective && !b.research_backtest_kind)
    .map(b => venueKey(b.track!)));
  for (const b of bets) {
    if (!b.track || b.race == null || !b.runner || !b.policy_id) continue;
    if ((scope === 'paper' && b.live_enabled) || (scope === 'live' && !b.live_enabled)) continue;
    const key = `${venueKey(b.track)}|${Number(b.race)}`;
    if (!byRace.has(key)) byRace.set(key,{key,track:b.track.toUpperCase(),race:Number(b.race),time:Infinity,picks:new Map()});
    const race = byRace.get(key)!;
    const time = Date.parse(b.start_time || '');
    if (Number.isFinite(time)) race.time = Math.min(race.time,time);
    const runner = runnerKey(b.runner);
    if (!race.picks.has(runner)) race.picks.set(runner,{name:b.runner,entries:new Map()});
    race.picks.get(runner)!.entries.set(b.policy_id,b);
    labels.set(b.policy_id,b.bucket_label || b.policy_id);
  }
  const races = [...byRace.values()].sort((a,b) =>
    (byTime ? (a.time===b.time ? 0 : a.time<b.time ? -1 : 1) : 0)
    || a.track.localeCompare(b.track) || a.race-b.race);
  const next = byTime ? races.find(r => {
    const picks = [...r.picks.values()].flatMap(p=>[...p.entries.values()]);
    // Closed/in-play markets cannot remain next up, even if one old bucket result is pending.
    if (picks.some(b=>b.in_play || b.market_status==='CLOSED')) return false;
    return picks.some(b=>currentPick(b) &&
      ((b.market_status==='OPEN' || b.market_status==='SUSPENDED')
        ? r.time>=now || (Number.isFinite(Date.parse(b.market_updated_at || '')) && now-Date.parse(b.market_updated_at!)<120000)
        : !b.market_status && r.time>=now));
  }) : undefined;
  return {races,labels,winnerVenues,nextKey:next?.key || null};
}
